<section class="infobox-section">
  <div class="container">
    <div class="infobox-grid">

      <div class="info-card">
        <span class="info-icon">
          <i class="fa fa-phone"></i>
        </span>
        <div class="info-body">
          <span class="info-label">{{'GB_Registration_CallUsNow' | translate}}</span>
          <span class="info-value" [innerHTML]="'GB_Registration_CallUsNow_Info' | translate"></span>
        </div>
      </div>

      <div class="info-divider" aria-hidden="true"></div>

      <div class="info-card">
        <span class="info-icon">
          <i class="fa fa-map-marker"></i>
        </span>
        <div class="info-body">
          <span class="info-label">{{'GB_Registration_ComeVisitUs' | translate}}</span>
          <span class="info-value" [innerHTML]="'GB_Registration_ComeVisitUs_Info' | translate"></span>
        </div>
      </div>

      <div class="info-divider" aria-hidden="true"></div>

      <div class="info-card">
        <span class="info-icon">
          <i class="fa fa-envelope"></i>
        </span>
        <div class="info-body">
          <span class="info-label">{{'GB_Registration_SendUsAMessage' | translate}}</span>
          <span class="info-value" [innerHTML]="'GB_Registration_SendUsAMessage_Info' | translate"></span>
        </div>
      </div>

    </div>
  </div>
</section>
